export default {
  root: ({ instance, props }) => {
    const size = props?.size || "pill";
    const severity = props?.severity || "gray";

    return {
      class: ["p-badge-root",
        {
            'p-badge-root_pill': size === 'pill',
            'p-badge-root_badge': size === 'badge',
            'p-badge-root_iconOnly': size === 'iconOnly',
            'p-badge-root_error': severity === 'error',
            'p-badge-root_warning': severity === 'warning',
            'p-badge-root_success': severity === 'success',
            'p-badge-root_blue': severity === 'blue',
            'p-badge-root_amber': severity === 'amber',
        }
      ],
    };
  },
};